import React, { Component } from 'react';
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import CheckBox from '~/Common-Objects/UI/Forms/CheckBox/CheckBox'
import Column from '~/Common-Objects/Grids/Column/Column'
import HeaderText from '~/Common-Objects/Text/HeaderText/HeaderText'
import Row from '~/Common-Objects/Grids/Row/Row'

class AutomationOptions extends Component {
    constructor(props) {
        super(props);
        this.state = {
            options: {}
        }
        this.toggle = this.toggle.bind(this)
    }

    componentDidMount() {
        this.setState({
            options: this.props.options
        })
    }

    toggle(event) {
        var options = this.state.options
        options[event.currentTarget.name] = event.currentTarget.checked
        this.setState({
            options
        })
    }

    render() {
        return (
            <div>
                <Row>
                    <Column xs={12}>
                        <HeaderText>Automation Options</HeaderText>
                    </Column>
                    <Column xs={12} margin={0}>
                        <div className="form-group">
                            <CheckBox checked={this.state.options.stopOnReply} name="stopOnReply" onClick={this.toggle}>Stop Emailing on Reply</CheckBox>
                            <p className="text-grey text-sml">to do this ensure we are watching all reply addresses assigned to each email <a onClick={() => this.props.history.push('/cp/company/mailboxes')}>here</a></p>
                        </div>
                    </Column>
                    <Column xs={6}>
                        <Button onClick={() => this.props.save(this.state.options)} className="button-md primary outline full-width">Save</Button>
                    </Column>
                    <Column xs={6}>
                        <Button onClick={this.props.cancel} className="button-md grey outline full-width">Cancel</Button>
                    </Column>
                </Row>
            </div>
        );
    }
}

export default AutomationOptions;